import { reference } from "./_duck"

export const REFERENCE_GET_REQUEST: string = reference.defineType("REFERENCE_GET_REQUEST")
export const REFERENCE_GET_SUCCESS: string = reference.defineType("REFERENCE_GET_SUCCESS")
export const REFERENCE_GET_FAILURE: string = reference.defineType("REFERENCE_GET_FAILURE")
